import {Component, Input} from '@angular/core';

@Component({
  selector: 'ngx-flash-loader',
  templateUrl: './flash-loader.component.html',
  styleUrls: ['./flash-loader.component.scss']
})
export class FlashLoaderComponent {
  @Input() showLoader: boolean = true;
}
